import Tracker from "../../../../prop-trackers/tracker.js";
import DictTracker from "../../../../prop-trackers/dict-tracker.js";
import SinglePropTracker from "../../../../prop-trackers/single-prop-tracker.js";
import PropTracker from "../../../../prop-trackers/prop-tracker.js";
import TrackerGroup from "../../../../prop-trackers/tracker-group.js";

class EnvLightDataGenerator extends Tracker {
    constructor(wrapCtx, evtCtx) {
        super();

        this._wrapCtx = wrapCtx;
        this._evtCtx = evtCtx;

        this._envLightCount = {};

        this._slideArrayTracker = new SinglePropTracker();

        this._slideTrackers = {};
        this._slideTrackerGroup = new TrackerGroup();

        this._slidesTracker = new PropTracker();

        this._outputTracker = new DictTracker();

        const needsUpdate = () => this.protected_needsUpdate();
        this._slideArrayTracker.listenNeedsUpdate(needsUpdate);
        this._slideTrackerGroup.listenNeedsUpdate(needsUpdate);
        this._slidesTracker.listenNeedsUpdate(needsUpdate);
    }

    track(tour, tourEvents) {
        if (tour) {
            this._slideArrayTracker.track(tour, tourEvents, "slides");
        } else {
            this._slideArrayTracker.track();
        }
    }

    protected_startUpdate() {
        this._slideArrayTracker.updateIfNeeded(({ prop: { newValue: newSlides } }) => {
            this._slidesTracker.track(newSlides, newSlides ? this._evtCtx.getEvents(newSlides) : null);
        });

        this._slidesTracker.updateIfNeeded(({ props }) => {
            for (const { key: index, oldValue: oldSlide, newValue: newSlide } of props.iterateModified()) {
                if (index !== "length") {
                    let tracker = this._slideTrackers[index];

                    if (!tracker && newSlide) {
                        tracker = new SinglePropTracker();

                        this._slideTrackers[index] = tracker;
                        this._slideTrackerGroup.add(tracker);
                    }

                    if (tracker) {
                        tracker.track(newSlide, newSlide ? this._evtCtx.getEvents(newSlide) : null, "envLight");
                    }

                    if (tracker && !newSlide) {
                        this._slideTrackerGroup.remove(tracker);
                        delete this._slideTrackers[index];
                    }
                }
            }
        });

        this._slideTrackerGroup.updateIfNeeded(({ trackers }) => {
            for (const tracker of trackers) {
                tracker.update(({ prop: { oldValue: oldPath, newValue: newPath } }) => {
                    if (typeof newPath === "string") {
                        let count;

                        if (newPath in this._envLightCount) {
                            count = this._envLightCount[newPath];
                        } else {
                            count = 0;

                            const envLightData = this._wrapCtx.getWrapper({ path: newPath });
                            this._outputTracker.setValue(newPath, envLightData);
                        }

                        this._envLightCount[newPath] = count+1;
                    }

                    if (typeof oldPath === "string") {
                        const count = this._envLightCount[oldPath]-1;

                        if (count === 0) {
                            delete this._envLightCount[oldPath];
                            this._outputTracker.deleteValue(oldPath);
                        } else {
                            this._envLightCount[oldPath] = count;
                        }
                    }
                });
            }
        });

        return this._outputTracker.startUpdate();
    }

    protected_finishUpdate() {
        return this._outputTracker.finishUpdate();
    }
}

export default EnvLightDataGenerator;
